import { Combobox, TextInput, Tooltip, useCombobox } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { EditProps } from "./util";

export interface Option {
  label: string;
  value: any;
}
export interface EditSelectProps extends EditProps {
  options?: Option[];
  searchable?: boolean;
}
const SelectProp = ({
  object,
  prop,
  mutate,
  label,
  placeholder,
  tooltip,
  options,
  disabled,
}: EditSelectProps) => {
  const { t } = useTranslation();
  const combobox = useCombobox();
  const [value, setValue] = useState<string>(object[prop]);
  // console.log("value :", value);
  const displayOption = options?.find((item) => item.value === value);
  const [search, setSearch] = useState(displayOption?.label || "");
  // console.log("search :", search);
  // useEffect(() => {
  //   setValue(object[prop]);
  // }, [object, prop]);
  const shouldFilterOptions = !!options?.every((item) => item.label !== search);
  // const shouldFilterOptions = false;
  const filteredOptions = shouldFilterOptions
    ? options?.filter((item) =>
        item.label.toLowerCase().includes(search.toLowerCase().trim())
      )
    : options;

  const displayOptions = filteredOptions?.map((item, index) => (
    <Combobox.Option value={item.value} key={item.value || index}>
      {item.label}
    </Combobox.Option>
  ));
  // console.log("value :", value);
  // console.log("displayOption :", displayOption);

  return (
    <Tooltip label={tooltip}>
      <Combobox
        disabled={disabled}
        onOptionSubmit={(optionValue) => {
          // console.log("submit optionValue :", optionValue);
          setValue(optionValue);
          const displayOption = options?.find(
            (item) => item.value === optionValue
          );
          // console.log("displayOption :", displayOption);
          setSearch(displayOption?.label || "");
          combobox.closeDropdown();
          const dto: any = {
            _id: object._id,
          };
          dto[prop] = value;
          mutate(dto, {
            onSuccess: () => {
              // setSearch(displayOption?.label || "");
              showNotification({
                message: t("Saved"),
                autoClose: true,
                color: "success",
              });
            },
          });
        }}
        store={combobox}
      >
        <Combobox.Target>
          <TextInput
            disabled={disabled}
            label={label}
            rightSection={<Combobox.Chevron />}
            rightSectionPointerEvents="none"
            onClick={() => combobox.openDropdown()}
            onFocus={() => combobox.openDropdown()}
            onBlur={() => {
              combobox.closeDropdown();
              const displayOption = options?.find(
                (item) => item.value === value
              );
              setSearch(displayOption?.label || "");
            }}
            placeholder={placeholder}
            value={search}
            onChange={(event) => {
              combobox.updateSelectedOptionIndex();
              setSearch(event.currentTarget.value);
            }}
          />
        </Combobox.Target>

        <Combobox.Dropdown>
          <Combobox.Options>
            {displayOptions?.length === 0 ? (
              <Combobox.Empty>Nothing found</Combobox.Empty>
            ) : (
              displayOptions
            )}
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    </Tooltip>
  );
};
export default SelectProp;
